import React, { useState, lazy, Suspense } from "react";
import Beatloader from "../../../Common/Loaders/Beatloader";
import TradeInvoicesPurchaseInvoiceSearch from "./TradeInvoicesPurchaseInvoiceSearch";
// import TradeInvoicesStandardPurchaseInvoice from "./TradeInvoicesStandardPurchaseInvoice";
// import RcmNote from "./RcmNote";
// import CreditNote from "./CreditNote";
// import CreditNoteNew from "./CreditNoteNew";
// import RCMNote_new from "./RCMNote_new";
const TradeInvoicesStandardPurchaseInvoice = lazy(() => import("./TradeInvoicesStandardPurchaseInvoice"))
const RCMNote_new = lazy(() => import("./RCMNote_new"));
const CreditNoteNew = lazy(() => import("./CreditNoteNew"));

const TradeInvoices = () => {
  const [activeTab, setActiveTab] = useState("purchase_invoice_search");
  const [pageLoader, setPageLoader] = useState(false);

  const TabButton = ({ id, label }) => (
    <button
      className={`btn mx-1 px-4 py-2 rounded-pill ${activeTab === id
        ? "btn-light shadow-sm border"
        : "btn-outline-light text-muted border"
        }`}
      style={{
        background: activeTab === id ? "#ffffff" : "#f5f5f5",
        borderColor: "#e4e4e4",
      }}
      onClick={() => setActiveTab(id)}
    >
      {label}
    </button>
  );

  return (
    <>
      {pageLoader ? (
        <Beatloader />
      ) : (
        <div className="page-wrapper">
          <div className="content">
            {/* Tabs */}
            <div className="d-flex flex-wrap align-items-center mb-4 gap-2">
              <TabButton
                id="purchase_invoice_search"
                label="Purchase Invoice Search"
              />
              <TabButton
                id="standard_purchase_invoice"
                label="Standard Purchase Invoice"
              />
              <TabButton id="rcm_note" label="RCM Note" />
              <TabButton id="credit_note" label="Credit Note" />
            </div>

            <div className="p-4">
              {activeTab === "purchase_invoice_search" && (
                <TradeInvoicesPurchaseInvoiceSearch />
              )}

              {/* standard_purchase_invoice */}
              {activeTab === "standard_purchase_invoice" && (
                <Suspense fallback={<div>Loading...</div>}>
                  <TradeInvoicesStandardPurchaseInvoice />
                </Suspense>
              )}

              {/* rcm_note */}
              {activeTab === "rcm_note" && <Suspense fallback={<div>Loading...</div>}>
                <RCMNote_new />
              </Suspense>}

              {/* credit_note */}
              {/* {activeTab === "credit_note" && <CreditNote />} */}
              {activeTab === "credit_note" && <Suspense fallback={<div>Loading...</div>}>
                <CreditNoteNew />
              </Suspense>}
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default TradeInvoices;
